import React, { useContext, useEffect, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import Select from 'react-select'
import axios from "axios";
import { currentDateAndTime, encodeData,decodeData,decodeUrl, findModuleByRoute, } from '../../Constants/constants';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { SubmitButton } from '../../Components/InputElements';
import PageTitle from '../../Components/PageTitle';
import { NoRecords } from '../../Components/Shimmer';
import {  useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const SalaryReport = () => {
     const { apiURL, apiHeaderFile, apiHeaderJSON,permissions } = useContext(ConfigContext);
        const query = useQuery();
        const encodedData = query.get("abs");
        const decodedDataId = decodeUrl(encodedData);
        const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
    
   
    const locationParams = useLocation();
    const queryParams = new URLSearchParams(locationParams.search);
   
     let routeId = findModuleByRoute(permissions,"PayrollProcess");
      console.log("routeId One=>>",routeId);
      routeId=routeId?.id;
      console.log("routeId",routeId);


    const navigate=useNavigate();
    const [rows, setRows] = useState([]);
    const [salaryRegister, setSalaryRegister] = useState(false);
    const [salaryRows, setSalaryRows] = useState([]);
    const [salaryHeaders, setSalaryHeaders] = useState([]);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [loading, setLoading] = useState(false);
    const [pinColumn, setPinColumn] = useState("");
    const [monthOptions, setMonthOptions] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const [department, setDepartment] = useState([]);
    const [location, setLocation] = useState([]);
    const [Pview, setPview] = useState(false);
    const [filter, setFilter] = useState({
        month: null,
        fromMonth: null,
        toMonth: null,
        location: null,
        department: null,
    });
    const [pagination, setPagination] = useState({
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false,
      });
    const [successMsg, setSuccessMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);

   
    const getList = () => {
        const headers = apiHeaderJSON;
        axios
          .get(`${apiURL}Payrolls/GetSalaryRegister`, {
            params: {
              month: filter?.month,
              department_id: filter?.department,
              location_id: filter?.location,
              date: currentDateAndTime()
            },
            headers,
          })
          .then(async (response) => {
            const data = response.data;
            console.log("salaryRegisterGetList response:", data);
            // console.log("salaryRegisterGetList data?.registerArray:", data?.registerArray[0]);
            let headerTitles= Array.isArray(data?.registerArray) && data?.registerArray?.length>0 && data?.registerArray[0];
            if (data?.success === true) {
                let salaryList=data?.registerArray;
                // console.log("data?.registerArray=>>",salaryList);
                if(Array.isArray(salaryList) && salaryList?.length>0){
                    // console.log("salaryList[0]=>>",salaryList[0]);
                    // console.log("data?.registerArray.shift()=>>",salaryList.shift());
                    setSalaryHeaders(data?.registerArray[0]);
                    salaryList.shift();
                    // console.log("salaryList=>>",salaryList);
                    setSalaryRows(salaryList);
                }
                if(headerTitles?.length>0 && salaryList?.length>0){
                  let { success, registerArray, message, month } = data;
                  registerArray= [headerTitles,...salaryList];
                  console.log("headerTitles final", headerTitles);
                  console.log("final", registerArray);
                  setSalaryRegister({success, registerArray, message, month});
                }
                
      
            
            //   console.log("Fetched salaryRegister data:", data?.registerArray);
            } else {
              
              console.error("Error fetching salary register data");
            }
            setLoadingFilter(false);
          })
          .catch((error) => {
            setLoadingFilter(false);
            console.error("Error during API call:", error);
          });
      };
   
    const getYealrySalary = () => {
        const headers = apiHeaderJSON;
        axios
          .get(`${apiURL}Payrolls/GetYealySalaryRegister`, {
            params: {
              fromMonth:filter?.fromMonth,
              toMonth:filter?.toMonth,
              date: currentDateAndTime()
            },
            headers,
          })
          .then(async (response) => {
            const data = response.data;
            console.log("getYealrySalary response:", data);
            // console.log("salaryRegisterGetList data?.registerArray:", data?.registerArray[0]);
            let headerTitles= Array.isArray(data?.registerArray) && data?.registerArray?.length>0 && data?.registerArray[0];
            if (data?.success === true) {
                let salaryList=data?.registerArray;
                // console.log("data?.registerArray=>>",salaryList);
                if(Array.isArray(salaryList) && salaryList?.length>0){
                    // console.log("salaryList[0]=>>",salaryList[0]);
                    // console.log("data?.registerArray.shift()=>>",salaryList.shift());
                    setSalaryHeaders(data?.registerArray[0]);
                    salaryList.shift();
                    // console.log("salaryList=>>",salaryList);
                    setSalaryRows(salaryList);
                }
                if(headerTitles?.length>0 && salaryList?.length>0){
                  let { success, registerArray, message, month } = data;
                  registerArray= [headerTitles,...salaryList];
                  console.log("headerTitles final", headerTitles);
                  console.log("final", registerArray);
                  setSalaryRegister({success, registerArray, message, month});
                }
                
      
            
            //   console.log("Fetched salaryRegister data:", data?.registerArray);
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: data?.message || "Unable to fetch salary register.",
                    confirmButtonText: "OK"
                });
              console.error("Error fetching salary register data");
            }
            setLoadingFilter(false);
          })
          .catch((error) => {
            setLoadingFilter(false);
            console.error("Error during API call:", error);
          });
      };

    const getMonthFilterList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetSalaryRegisterMonthYearFilterData`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                // console.log("getMonthFilterList", data);
                if (data?.success === true) {
                    setMonthOptions(data?.filterData);
                    
                    if(Array.isArray(data?.filterData) && data?.filterData.length>0){
                        // setFilter({
                        //     ...filter,
                        //     month: data?.filterData[0]
                        // })
                        // setIsChanged(true);
                    }
                }
            });
    };

    const getDepartmentFilterList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetDepartments`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                // console.log("getDepartmentFilterList", data);
                if (data?.success === true) {
                    let row = data?.departments?.map((val) => {
                        return { value: val?.department_id, label: val?.department_title }
                    })
                    // row?.splice(0, 0, { value: "All", label: "All" });
                    // let allDepartmentRow = data?.departments?.map((val) => {
                    //     return val?.department_id
                    // });
                    // allDepartmentRow = allDepartmentRow?.join(",");
                    setDepartment(row)


                } else {

                }
            });
    };
    const getLocationFilterList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetLocations`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                // console.log("getLocationFilterList", data);
                if (data?.success === true) {
                    let row = data?.locations?.map((val) => {
                        return { value: val?.location_id, label: val?.location_title }
                    })
                    setLocation(row);


                } else {

                }
            });
    };
    useEffect(() => {
        getMonthFilterList();
        getDepartmentFilterList();
        getLocationFilterList();
    }, []);
    // useEffect(() => {
    //     if(isChanged)
    //     getList();
    // }, [isChanged]);

    const handleMultiSelect = (fieldName, selectedOptions) => {
        const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
        // console.log(ids.join(','))
        setFilter(prevFormData => ({
            ...prevFormData,
            [fieldName]: ids.join(',')
        }));
    };
    // console.log("filter",filter);

    const handleExcelDownload = async () => {
        const headers = apiHeaderJSON;

        // Swal.fire({
        //     title: 'Please wait...',
        //     html: 'Your file is being prepared for download.',
        //     allowOutsideClick: false,
        //     didOpen: () => {
        //         Swal.showLoading();
        //     }
        // });

        // axios.get(`${apiURL}Payrolls/GetSalaryRegister`, {
        //     params: {
        //         month: filter?.month,
        //         department_id: filter?.department,
        //         location_id: filter?.location
        //     },
        //     headers
        // })
        //     .then(async (response) => {
                const { success, registerArray, message, month } = salaryRegister;
                console.log("registerArray",registerArray);
                if (success === true) {
                    // Assuming `registerArray` is an array of objects (representing rows of data)
                    const filteredData = registerArray.slice(0); // Use this if you need to remove specific rows

                    // Explicitly set the headers based on the object keys (remove the index row)
                    const headers = Object.keys(filteredData[0]);

                    // Convert the filtered data to a worksheet without auto-indexing
                    const worksheet = XLSX.utils.json_to_sheet(filteredData, { skipHeader: true });

                    // Create a new workbook and append the worksheet
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, worksheet, 'Salary Register');

                    // Format the current date and time
                    const date = new Date();
                    const dateString = date.toLocaleDateString();

                    // Save the file with the correct format
                    XLSX.writeFile(wb, `${localStorage.getItem("company_code")} Salary Register ${month ? month : "_"}.xlsx`);

                    Swal.fire({
                        title: `<strong>Success</strong>`,
                        text: message,
                        icon: 'success',
                        showConfirmButton: true,
                        allowOutsideClick:false,
                    });
                } else {
                    Swal.fire({
                        title: `<strong>Failed</strong>`,
                        text: message,
                        icon: 'error',
                        showConfirmButton: true,
                        allowOutsideClick:false,
                    });
                }
            // })
            // .catch((error) => {
            //     Swal.close();
            //     Swal.fire({
            //         title: `<strong>Failed</strong>`,
            //         text: error.response ? error.response.message : error.message,
            //         icon: 'error',
            //         showConfirmButton: true
            //     });
            // });
    }



    const SwitchView = () => {
         setPview(prev => !prev);
         setFilter({
            month: null,
            fromMonth: null,
            toMonth:null,
            location: null,
            department: null,
        });
        setSalaryHeaders([]);
        setSalaryRegister(false);
        setSalaryRows([]);
    }

    const handleFilter = () => {

    }

    const handleClearAll = () => {
        setFilter({
            month: null,
            fromMonth: null,
            toMonth:null,
            location: null,
            department: null,
        });
        setSalaryHeaders([]);
        setSalaryRegister(false);
        setSalaryRows([]);
    }

    return (
        <div class="main-content">
            <div class="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`Salary Report`} primary={`Home`} />
                    <div className="card">
                        <div className="card-body">
                            <div>
                                <div className="card-header">
                                    <div className="row">
                                        <p
                                            className="text-end text-primary"
                                            onClick={SwitchView}
                                            style={{ cursor: "pointer", textDecoration: "underline" }}
                                        >
                                            {Pview ? "Monthly Salary" : "Yearly Salary"}
                                        </p>
                                    </div>
                                    {Pview ? 
                                    <>
                                    <div className="row">
                                        {/* from month  */}
                                        <div className='col-md-3'>
                                            <label htmlFor="fromMonth" className="form-label" > From Month </label>
                                            <Select
                                                options={monthOptions}
                                                value={
                                                    filter?.fromMonth
                                                        ? monthOptions.find(option => option.value === filter?.fromMonth)
                                                        : null
                                                }
                                                onChange={(selectOption) => setFilter({ ...filter, fromMonth: selectOption?.value })}
                                                placeholder={`Select Month`} />
                                        </div>
                                        {/* to Month  */}
                                         <div className='col-md-3'>
                                            <label htmlFor="toMonth" className="form-label" > To Month </label>
                                            <Select
                                                options={monthOptions}
                                                value={
                                                    filter?.toMonth
                                                        ? monthOptions.find(option => option.value === filter?.toMonth)
                                                        : null
                                                }
                                                onChange={(selectOption) => setFilter({ ...filter, toMonth: selectOption?.value })}
                                                placeholder={`Select Month`} />
                                        </div>       
                                        <div className='col-md-6' >
                                            <div className='row'>
                                                <div className='col-md-4'>
                                                    <div>
                                                        <label>Apply filter</label>
                                                    </div>
                                                    <SubmitButton onClick={(e)=>{ 
                                                        if(!loadingFilter){
                                                            setLoadingFilter(true);
                                                            getYealrySalary();
                                                        } }}
                                                    loading={loadingFilter} otherClasses='w-100' disabled={ !filter?.fromMonth || !filter?.toMonth} 
                                                    loadingMessage='Loading' buttonName={'Filter'} icon={'ri-filter-3-fill'} 
                                                    type='info' iconSide='left' />
                                                </div>
                                                <div className='col-md-4'>
                                                    <div> 
                                                        <label>Clear Filter</label> 
                                                    </div>
                                                    <SubmitButton onClick={(e)=>{ handleClearAll()}}
                                                    otherClasses='w-100' disabled={ (!filter?.fromMonth || !filter?.toMonth) || loadingFilter} 
                                                    loadingMessage='Loading' buttonName={'Clear'} icon={'ri-database-2-line'} 
                                                    type='secondary' iconSide='left' />
                                                </div>
                                                <div className='col-md-4'>
                                                    <div>
                                                        <label>Export Excel</label>
                                                    </div>
                                                    <SubmitButton onClick={(e)=>{ handleExcelDownload() }}
                                                    disabled={!filter?.fromMonth || !filter?.toMonth || loadingFilter || !salaryRegister } 
                                                    loadingMessage='Processing' buttonName={'Download'} icon={'ri-file-excel-line'} 
                                                    type='success' iconSide='left' />
                                                </div>
                                            </div>
                                        </div>
                                       
                                    </div>
                                    </>
                                    
                                    :
                                    
                                    <div className="row">
                                        <div className='col-md-3'>
                                            <label htmlFor="Location" className="form-label" > Select Month </label>
                                            <Select
                                                options={monthOptions}
                                                value={
                                                    filter?.month
                                                        ? monthOptions.find(option => option.value === filter?.month)
                                                        : null
                                                }
                                                onChange={(selectOption) => setFilter({ ...filter, month: selectOption?.value })}
                                                placeholder={`Select Month`} />
                                        </div>

                                        <div className="col-md-3 position-relative mb-5">

                                            {/* <label htmlFor="Department" className="form-label" > Department </label> */}
                                            {/* <Select
                                                value={filter?.department ? department.find(option => option.value === filter?.department) : null}
                                                options={department}
                                                onChange={(selectOption) => setFilter({ ...filter, department: selectOption?.value })}
                                                hint={`Select Department`}
                                                isDisabled={!filter?.month}
                                            /> */}
                                            <div style={{ zIndex: 10, width: "90%" }}className=" position-absolute">
                                                <label>Department</label>
                                                <Select
                                                    onChange={(selectedOptions) => handleMultiSelect("department", selectedOptions)}
                                                    placeholder={filter?.month ? "All" : "Select Department"}
                                                    isMulti
                                                    options={department}
                                                    isDisabled={!filter?.month}
                                                    value={filter?.department ? filter?.department.split(',').map(id => department.find(option => option.value == id)) : null}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-3 position-relative mb-5">
                                            <label htmlFor="Location" className="form-label" > Location </label>
                                            {/* <Select
                                                value={filter?.location ? location.find(option => option.value === filter?.location) : null}
                                                options={location}
                                                onChange={(selectOption) => setFilter({ ...filter, location: selectOption?.value })}
                                                hint={`Select Location`}
                                                isDisabled={!filter?.month}
                                            /> */}
                                            <div style={{ zIndex: 10, width: "90%" }}className=" position-absolute">
                                                <Select
                                                    onChange={(selectedOptions) => handleMultiSelect("location", selectedOptions)}
                                                    placeholder={filter?.month ? "All" : "Select Location"}
                                                    isMulti
                                                    options={location}
                                                    isDisabled={!filter?.month}
                                                    value={filter?.location ? filter?.location.split(',').map(id => location.find(option => option.value == id)) : null}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-md-3' >
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div>
                                                        <label>Apply Filter</label>
                                                    </div>
                                                    <SubmitButton onClick={(e)=>{ 
                                                        if(!loadingFilter){
                                                            setLoadingFilter(true);
                                                            getList();
                                                        } }}
                                                    loading={loadingFilter} otherClasses='w-100' disabled={ !filter?.department && !filter?.location && !filter?.month} 
                                                    loadingMessage='Loading' buttonName={'Filter'} icon={'ri-filter-3-fill'} 
                                                    type='info' iconSide='left' />
                                                </div>
                                                <div className='col-md-6'>
                                                    <div> 
                                                        <label>Clear Filter</label> 
                                                    </div>
                                                    <SubmitButton onClick={(e)=>{ handleClearAll()}}
                                                    otherClasses='w-100' disabled={ (!filter?.department && !filter?.location && !filter?.month) || loadingFilter} 
                                                    loadingMessage='Loading' buttonName={'Clear'} icon={'ri-database-2-line'} 
                                                    type='secondary' iconSide='left' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-12 mt-1'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                            <div className='d-flex gap-3'>
                                            { decodedData?.includes(3) && ( 
                                                <div className=''>
                                                    <div>
                                                        <label>Export Excel</label>
                                                    </div>
                                                    <SubmitButton onClick={(e)=>{ handleExcelDownload() }}
                                                    disabled={!filter?.month || loadingFilter || !salaryRegister } 
                                                    loadingMessage='Processing' buttonName={'Download'} icon={'ri-file-excel-line'} 
                                                    type='success' iconSide='left' />
                                                </div>)}
                                                { decodedData?.includes(3) && ( 
                                                        <div className=''>
                                                            <div>
                                                                <label className=' noWrap'>Change Heads Order</label>
                                                            </div>
                                                            <button className="btn btn-primary btn-label waves-effect waves-light noWrap" 
                                                            disabled={loadingFilter} 
                                                            onClick={() => navigate(`/EditSalaryHeadOrder?abs=${encodeData(decodedDataId)}`)}
                                                            // onClick={handleNavigation}
                                                            >
                                                                <i className="bx bx-list-ul label-icon align-middle fs-4 " /> Edit Order
                                                            </button>
                                                            {/* <button
                                                                type="button"
                                                                disabled={!filter?.checkHeadType && !filter?.keyword}
                                                                className={`btn btn-secondary btn-label waves-effect waves-light noWrap`}
                                                            >
                                                                <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> Edit Order</button> */}
                                                        </div>)}
                                                        </div>
                                                { decodedData?.includes(3) && ( 
                                                <div className=''>
                                                    <div>
                                                        <label>Payroll</label>
                                                    </div>
                                                        <SubmitButton onClick={()=>{ 
                                                            if(!loadingFilter){
                                                                navigate(`/PayrollProcess?abs=${encodeData(routeId)}`);
                                                            }
                                                         }} disabled={loadingFilter}  buttonName={'Payroll'} icon={'ri-coin-line'} 
                                                        type='primary' iconSide='left' float='right' />
                                                </div>)}
                                            </div>
                                        </div>
                                    </div>
                                    
                                    }

                                    {/* success message */}
                                    <div style={{ width: "60%", margin: "auto" }}>
                                        {successMsg ?
                                            <div className=" position-relative alert alert-success mt-3" role="alert">
                                                {successMsg} <span onClick={() => { setSuccessMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                            </div>
                                            : null
                                        }
                                        {/* error message */}
                                        {errorMsg ?
                                            <div className=" position-relative alert alert-danger mt-3" role="alert">
                                                {errorMsg} <span onClick={() => { setErrorMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                            </div> : null
                                        }
                                    </div>
                                </div>
                                </div>
                            <div className="row">
                                <div style={{ maxHeight: '65vh', overflowY: 'auto' }} className="col-sm-12">
                                    {/* <table className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped" style={{ minWidth: '100%' }} >
                                        <thead className="bg-primary text-light bg-gradient  sticky-top z-1">
                                            <tr>
                                            {salaryHeaders?.map((val, idx) => (
                                                <th key={idx} className="noWrap">{val}</th>
                                            ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {salaryRows?.length === 0 ? (
                                            <tr>
                                                <td colSpan={5}>
                                                <NoRecords />
                                                </td>
                                            </tr>
                                            ) : (
                                            
                                            salaryRows?.map((row, idx) => (
                                                <tr key={row.employee_id || idx}>
                                                {row?.map((col, index) => (
                                                    <td key={index} className="noWrap">{col}</td>
                                                ))}
                                                </tr>
                                            ))
                                            )}
                                        </tbody>
                                    </table> */}
                                    <table
                                    className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative"
                                    style={{ minWidth: '100%' }}
                                    >
                                        <thead className="bg-primary text-light bg-gradient sticky-top-h">
                                            <tr>
                                            {salaryHeaders?.map((val, idx) => (
                                                <th
                                                key={idx}
                                                className={`noWrap ${
                                                    idx === 1 ? 'sticky-column-h sticky-column-2' : idx === 2 ? 'sticky-column-h sticky-column-3' : ''
                                                }`}
                                                >
                                                {val}{}
                                                </th>
                                            ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {salaryRows?.length === 0 ? (
                                            <tr>
                                                <td colSpan={5}>
                                                <NoRecords />
                                                </td>
                                            </tr>
                                            ) : (
                                            salaryRows?.map((row, idx) => (
                                                <tr key={row.employee_id || idx}>
                                                {row?.map((col, index) => (
                                                    <td
                                                    key={index}
                                                    className={`noWrap ${
                                                        index === 1 ? 'sticky-column-d sticky-column-2' : index === 2 ? 'sticky-column-d sticky-column-3' : ''
                                                    }`}
                                                    >
                                                    {col}
                                                    </td>
                                                ))}
                                                </tr>
                                            ))
                                            )}
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SalaryReport;
